import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './SingleSubscription.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class SInglesubscription extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.update = this.update.bind(this);
    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    

    public handleChange(key,rowData, e) {

        // set subscription data
        console.log(rowData);

        rowData[key] = e.target.value;

        this.forceUpdate();

        console.log(e.target.value);
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async update() {

        const state = this.state;

        const subscription = state.data.subscription;

        state.data.loaded = false;

       

        console.log(subscription);

        const retVal = confirm("Do you want to continue ? Changes are permanent.");
    
        if(retVal === true) {

                  this.setState(state);
                  console.log('edit accepted');
                  const res = await this.props.services.adminAPI.updateSingleSubscription(subscription.id, subscription);
                  if (res.ok) {

                    toast.success('subscription updated successfully!');

                    state.data.subscription = res.data;
                
                }

                else {
                    toast.error('Error updating subscription!');
                }

                state.data.loaded = true;

                this.setState(state);

                return true;
        } else {
            console.log('edit canceled')
            return false;
        }
    }


    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: subscriptionID } } = match;

      
        const subscriptionRes = await adminAPI.getSingleSubscription(subscriptionID);

        if (subscriptionRes.ok) {
            
            const subscription = subscriptionRes.data;

            this.setState(
                {
                     data: {
                        subscription,
                        loaded: true
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
                
                <ContentRow>
                    <table>
                        <tbody>
                            <tr>
                                <td>Subscription Name</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  disabled={true} value={data.subscription.UserName} onChange= {(e) => this.handleChange('UserName', data.subscription, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>Subscription Email</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  disabled={true} value={data.subscription.Email} onChange= {(e) => this.handleChange('Email', data.subscription, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>Package Name</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  disabled={true} value={data.subscription.PackageName} onChange= {(e) => this.handleChange('PackageName', data.subscription, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>Subscription Level</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  value={data.subscription.SubscriptionLevel} onChange= {(e) => this.handleChange('SubscriptionLevel', data.subscription, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>Subscription Status</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  value={data.subscription.SubscriptionStatus} onChange= {(e) => this.handleChange('SubscriptionStatus', data.subscription, e)} />
                                </td>
                            </tr>

                            <tr>
                                <td>Package ID</td> 
                                <td>
                                    {/*tslint:disable-next-line jsx-no-lambda*/}
                                    <input  value={data.subscription.PackageId} onChange= {(e) => this.handleChange('PackageId', data.subscription, e)} />
                                </td>
                            </tr>


                            
                            
                            </tbody>
                    </table>

                    
                </ContentRow>

                <ContentRow>
 
                <Button  onClick={this.update}>Submit Changes</Button>
                    </ContentRow>

              </Content>

              
              </Wrapper>
        );

    }

}

export default withServices(SInglesubscription);


// WEBPACK FOOTER //
// ./src/pages/Admin/Subscriptions/SingleSubscription/SingleSubscription.tsx